import React from 'react';
import { Button, Chip, Stack, Tooltip } from '@mui/material';
import { useSetUserActive } from '../useSetUserActive';

/**
 * The user drawer header's status: an "Inactive" chip for a deactivated user, and a
 * Deactivate / Activate button that acts straight away after the admin confirms (not with
 * the form's Save). Disabled on the admin's own record.
 */
export const UserActiveButton = ({ user }) => {
	const { isActive, canChange, isLoading, setActive } = useSetUserActive(user);

	return (
		<Stack direction='row' spacing={1} alignItems='center'>
			{!isActive && <Chip size='small' label='Inactive' />}
			<Tooltip title={canChange ? '' : 'You cannot deactivate yourself'}>
				{/* The span keeps the tooltip working while the button is disabled */}
				<span>
					<Button
						size='small'
						variant='outlined'
						color={isActive ? 'error' : 'primary'}
						onClick={() => setActive(!isActive)}
						disabled={!canChange || isLoading}
					>
						{isActive ? 'Deactivate' : 'Activate'}
					</Button>
				</span>
			</Tooltip>
		</Stack>
	);
};
